(() => {
  'use strict';

  let syncing = false;

  const updateCartBubble = (cart) => {
    const link = document.querySelector('#cart-icon-bubble');
    if (!link) return;

    const count = Math.max(0, Number(cart?.item_count || 0));
    let bubble = link.querySelector('.cart-count-bubble');

    if (count < 1) {
      bubble?.remove();
      link.setAttribute('aria-label', 'Sepet, 0 ürün');
      return;
    }

    if (!bubble) {
      bubble = document.createElement('div');
      bubble.className = 'cart-count-bubble';
      bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden"></span>';
      link.appendChild(bubble);
    }

    const visibleCount = bubble.querySelector('[aria-hidden="true"]');
    const accessibleCount = bubble.querySelector('.visually-hidden');

    if (visibleCount) visibleCount.textContent = count < 100 ? String(count) : '';
    if (accessibleCount) accessibleCount.textContent = `Sepette ${count} ürün var`;
    link.setAttribute('aria-label', `Sepet, ${count} ürün`);
  };

  const refreshCartUi = async () => {
    if (syncing) return;
    syncing = true;

    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store'
      });

      if (!response.ok) throw new Error('Sepet sayacı yenilenemedi.');

      const cart = await response.json();
      updateCartBubble(cart);

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'puane-b2b-product-v4',
          cartData: cart
        });
      }
    } catch (error) {
      console.error('[Puane B2B] Sepet göstergesi yenilenemedi:', error);
    } finally {
      syncing = false;
    }
  };

  document.addEventListener('cart:refresh', refreshCartUi);
  window.addEventListener('pageshow', refreshCartUi);
})();
